export const Menu = {
    SalesFUND_MANAGER_AUDIT_QUERYTIMERANGE: 'Query Time Range',
    SalesFUND_MANAGER_AUDIT_QUERYTIMERANGE_TIME30: 'Last 30 Days',
    SalesFUND_MANAGER_AUDIT_QUERYTIMERANGE_TIME60: 'Last 60 Days',
    SalesFUND_MANAGER_AUDIT_QUERYTIMERANGE_TIME90: 'Last 90 Days',
    SalesFUND_MANAGER_AUDIT_QUERYTIMERANGE_TIMEALL: 'All',
    SalesFUND_MANAGER_WALLET_QUERYTIMERANGE: 'Query Time Range',
    SalesFUND_MANAGER_WALLET_QUERYTIMERANGE_TIME30: 'Last 30 Days',
    SalesFUND_MANAGER_WALLET_QUERYTIMERANGE_TIME60: 'Last 60 Days',
    SalesFUND_MANAGER_WALLET_QUERYTIMERANGE_TIME90: 'Last 90 Days',
    SalesFUND_MANAGER_WALLET_QUERYTIMERANGE_TIMEALL: 'All',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED: 'IB Rebate Related Config',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED_UPGRADEIB: 'Upgrade IB',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED_REBATECONFIG: 'IB Rebate Config',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED_SHOWINTERESTFREEGROUP: 'Show Interest-Free Group',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED_SHOWLOWSPREADGROUP: 'Show Low Spread Group',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED_COPYNETTINGSTRATEGY: 'Copy Rebate Strategy To Netting Sub-Type',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED_REBATESYNC: 'Enable One-Click Rebate Strategy Sync',
    SalesCLIENT_WORKORDER_UPGRADEIB: 'IB Rebate Config Work Order List',
    SalesCLIENT_WORKORDER_UPGRADEIB_CONFIG: 'IB Rebate Config',
    SalesCLIENT_WORKORDER_UPGRADEIB_DETAIL: 'IB Rebate Config Ticket Details',
    SalesCLIENT_MANAGER_IBREBATESTRATEGY: 'IB Rebate Strategy',
    SalesTEAM_MANAGER_IBREBATESTRATEGY: 'IB Rebate Strategy',
    SalesCLIENT_MANAGER_LIST_DETAIL_ROLEINFO_SALES_EDIT: 'Edit Sale',
    SalesTEAM_MANAGER_CLIENT_DETAIL_ROLEINFO_SALES_EDIT: 'Edit Sale',
};
